import { TFunction } from 'i18next';
import { StepConfigItem } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import StepperForm1 from './components/step1';

export const ContactUsConfig = (t: TFunction): StepConfigItem[] => {
  return [
    {
      step1: {
        component: <StepperForm1 callStepSpecificAction={true} />,
        step: 0,
        footerNavigationProps: {
          buttonTitle: t('checkAvailability.send'),
          fullWidth: true,
        },
      },
    },
  ];
};
